<div
  class="widget-type-content-component relative w-full h-full"
  [ngClass]="widget().type"
>
  @if (type().component) {
    <div class="header-template absolute right-0 top-1 z-40">
      @if (headerTemplate) {
        <ng-container [ngTemplateOutlet]="headerTemplate"></ng-container>
      }
    </div>

    <ndc-dynamic
      #component
      class="w-full h-full"
      [ndcDynamicComponent]="type().component"
      [ndcDynamicInputs]="type().inputs"
    >
    </ndc-dynamic>
  } @else {
    <div
      class="flex overflow-auto p-2 w-full h-full border-2 border-gray-300 border-dashed dark:border-gray-500"
    >
      <span
        class="m-auto text-xs italic text-center text-gray-500 whitespace-normal break-words dark:text-gray-400"
      >
        {{ 'dashboard.widget.UNAVAILABLE_IN_APP' | transloco }}
      </span>
    </div>
  }
</div>
